import { render } from "./Main.vue?vue&type=template&id=283c2fff"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"
script.render = render

export default script